import { pick } from 'lodash'

const transformToUpdateDishTypeNotesArgs = data => pick(data, ['notes'])

export default transformToUpdateDishTypeNotesArgs
